import { Injectable } from '@angular/core';

/*
  Generated class for the BackgroundsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class BackgroundsProvider {
  backgrounds: any = null;

  constructor() {
    // console.log('Hello BackgroundsProvider Provider');
  }


  getBackgrounds(){
    if(this.backgrounds == null){
      this.backgrounds = [];
      this.initBackgrounds();
    }

    // console.log("getSizes",this.backgrounds);
    return this.backgrounds;
  }
  getBackground(index){
    // console.log("getSize", index);
    if(this.backgrounds == null){
      this.backgrounds = [];
      this.initBackgrounds();
    }
    // console.log("this.backgrounds",this.backgrounds);
    return this.backgrounds[index];
  }

  initBackgrounds(){
    this.backgrounds=[];
    this.backgrounds.push({
      title:"Clear",
      category:"clear",
      subcategory:"clear",
      class:"background_clear"
    });

    this.backgrounds.push({
      title:"Gradient bottom",
      category:"gradient",
      subcategory:"linear_gradient",
      class:"background_gradient_bottom",
      params:{
        x0:0,
        y0:1,
        x1:0,
        y1:0
      },
    });
    this.backgrounds.push({
      title:"Gradient top",
      category:"gradient",
      subcategory:"linear_gradient",
      params:{
        x0:0,
        y0:0,
        x1:0,
        y1:1
      },
      class:"background_gradient_top"
    });
    this.backgrounds.push({
      title:"Gradient left",
      category:"gradient",
      subcategory:"linear_gradient",
      class:"background_gradient_left",
      params:{
        x0:0,
        y0:0,
        x1:1,
        y1:0
      },
    });
    this.backgrounds.push({
      title:"Gradient right",
      category:"gradient",
      subcategory:"linear_gradient",
      class:"background_gradient_right",
      params:{
        x0:1,
        y0:0,
        x1:0,
        y1:0
      },
    });
    this.backgrounds.push({
      title:"Radial inset",
      category:"gradient",
      subcategory:"radial_gradient",
      class:"background_gradient_radial",
      params:{
        x0:1,
        y0:0,
        r0:1,
        x1:0,
        y1:0,
        r1:0
      },
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/backgrounds/backgrounds.ts